import { render, staticRenderFns } from "./CopyLinkedCheckBehaviorEditor.vue?vue&type=template&id=0867511a&scoped=true&"
import script from "./CopyLinkedCheckBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./CopyLinkedCheckBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CopyLinkedCheckBehaviorEditor.vue?vue&type=style&index=0&id=0867511a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867511a",
  null
  
)

export default component.exports